import { ApiEndpoints } from "../core";
import { httpClient } from "../core";
import {
  addFormatState,
  addSessionState,
  changeSessionLoading,
  deleteSessionFormatState,
  deleteSessionState,
  dispatch,
  editSessionFormatState,
  editSessionState,
  setDuplicateSessions,
  setErrorMessage,
  setFormatSessionById,
  setFormatSessionId,
  setSessionById,
  setSessionScheduleState,
  setSessionState,
  setSuccessMessage,
} from "../redux";

export const getSession = async (
  refresh = false,
  page,
  limit,
  search = "",
  sort
) => {
  try {
    // Set Loading if it is not refresh
    if (!refresh) dispatch(changeSessionLoading(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.getSessions, {
      params: {
        page,
        limit,
        name: search,
        sort,
      },
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setSessionState({ sessions: resp.data.results, refresh }));

    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.results;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeSessionLoading(false));
  }
};

export const addSession = async (name, details, thankyou, warmupTime) => {
  try {
    // Set Loading
    dispatch(changeSessionLoading(true));

    // API Fetching
    const resp = await httpClient().post(ApiEndpoints.createSession, {
      name,
      details,
      thankyou,
      warmupTime,
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(addSessionState(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.result;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeSessionLoading(false));
  }
};

export const getSessionById = async (id) => {
  try {
    // Set Loading
    dispatch(changeSessionLoading(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.sessionById + "/" + id);

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setSessionById(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.result;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeSessionLoading(false));
  }
};

export const editSession = async (id, sessionData) => {
  try {
    // Set Loading
    dispatch(changeSessionLoading(true));

    // API Fetching
    const resp = await httpClient().patch(
      ApiEndpoints.editSession + "/" + id,
      sessionData
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(editSessionState(resp.data.result));
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeSessionLoading(false));
  }
};

export const deleteSession = async (id) => {
  try {
    // Set Loading
    dispatch(changeSessionLoading(true));

    // API Fetching
    const resp = await httpClient().delete(
      ApiEndpoints.sessionDelete + "/" + id
    );
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(deleteSessionState(id));
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeSessionLoading(false));
  }
};

export const duplicateApi = async (selectedSessions) => {
  try {
    // Set Loading
    dispatch(changeSessionLoading(true));

    // API Fetching
    const resp = await httpClient().post(ApiEndpoints.duplicateSession, {
      sessionIds: selectedSessions,
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setDuplicateSessions(resp.data.results));
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeSessionLoading(false));
  }
};

//for format

//add format
export const addFormat = async (formData) => {
  try {
    // Set Loading
    dispatch(changeSessionLoading(true));

    // API Fetching
    const resp = await httpClient().post(ApiEndpoints.createFormat, {
      ...formData,
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(addFormatState(resp.data.result));
    dispatch(setSuccessMessage(resp.data.message));

    return true;
  } catch (error) {
    console.log(error);

    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeSessionLoading(false));
  }
};

export const getSessionFormatById = async (
  id,
  page,
  limit,
  search = "",
  sort
) => {
  try {
    // Set Loading
    dispatch(changeSessionLoading(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.sessionFormatById + id, {
      params: {
        page,
        limit,
        format: search,
        sort,
      },
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setFormatSessionById(resp.data.results));
    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.results;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeSessionLoading(false));
  }
};

export const getFormatSessionById = async (id) => {
  try {
    // Set Loading
    dispatch(changeSessionLoading(true));

    // API Fetching
    const resp = await httpClient().get(
      ApiEndpoints.formatSessionById + "/" + id
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(setFormatSessionId(resp.data.result));
    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.result;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeSessionLoading(false));
  }
};

export const deleteSessionFormat = async (id) => {
  try {
    // Set Loading
    dispatch(changeSessionLoading(true));

    // API Fetching
    const resp = await httpClient().delete(
      ApiEndpoints.sessionFormatDelete + "/" + id
    );
    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(deleteSessionFormatState(id));
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeSessionLoading(false));
  }
};

export const editFormat = async (id, formData) => {
  try {
    // Set Loading
    dispatch(changeSessionLoading(true));

    // API Fetching
    const resp = await httpClient().patch(
      ApiEndpoints.editSessionFormat + "/" + id,
      formData
    );

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(editSessionFormatState(resp.data.result));
    dispatch(setSuccessMessage(resp.data.message));
    return true;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeSessionLoading(false));
  }
};

export const getScheduleDetails = async (
  refresh = false,
  page,
  limit,
  search = "",
  sort
) => {
  try {
    // Set Loading if it is not refresh
    if (!refresh) dispatch(changeSessionLoading(true));

    // API Fetching
    const resp = await httpClient().get(ApiEndpoints.getSessions, {
      params: {
        page,
        limit,
        name: search,
        sort,
        scheduled: "YES",
      },
    });

    // Handle Error
    if (resp.status > 201 || !resp.data.success) {
      throw new Error(resp.data.message);
    }

    // Update to Store
    dispatch(
      setSessionScheduleState({ sessionsSchedule: resp.data.results, refresh })
    );

    // dispatch(setSuccessMessage(resp.data.message));
    return resp.data.results;
  } catch (error) {
    // Set Error message to store
    dispatch(setErrorMessage(error.message ?? "Error happended"));
    dispatch(changeSessionLoading(false));
  }
};
